<template>
    <!-- See: `getFullVh()` -->
    <div style="overflow: hidden; height: 0">
        <div id="measure-vh" style="position: fixed; height: 100vh"></div>
    </div>
   <!-- showPopUpTwoOptions --><transition name="fade">
    <div  v-show="showPopUpTwoOptions" class="modal-overlayfrombottomblur" style="z-index: 997;">
      <div class="modal" style="padding-top: 2vh; padding-bottom: 2vh; width: 90%"> 
        <!-- put in table for dev speed need to learn more about flex -->
        <table border=0 width=85%> 
          <tr>
            <td>
              <div class="lt-blue txtc" :style="{ 'font-size': fontSizeNormalInPXToUse * 1.1 + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }">                 
              {{ this.PopUpTwoOptionsTitle }}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="lt-blue txtc" style="padding-top: 1vh" :style="{ 'font-size': fontSizeNormalInPXToUse * 0.9 + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }">                 
              {{ this.PopUpTwoOptionsMessage }}<span v-if="this.PopUpTwoOptionsMessage !==''"><br><br><b>{{this.PopUpTwoOptionsMessage2}}</b>{{this.PopUpTwoOptionsMessage3}}</span>
              </div>
            </td>
          </tr> 
          <tr v-show="this.showButton1===true">
            <td>
              <div style="padding-top: 2vh; padding-bottom: 2vh;"><button class="widebtn" style="width: 100%; height: 6vh; " :style="{ 'font-size': fontSizeNormalInPXToUse + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }" @click="this.doOption1();">{{ this.option1ButtonText }}</button></div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="padding-bottom: 2vh;"><button class="widebtn" style="width: 100%; height: 6vh; " :style="{ 'font-size': fontSizeNormalInPXToUse + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }" @click="this.doOption2();">{{ this.option2ButtonText }}</button></div>
            </td>
          </tr>
          <tr> <!-- spacer --> <td><div></div></td>
          </tr>
        </table>       
      </div>
    </div>
  </transition>
    <div v-show="this.showAccountScreen===true && (this.userData.isManager === undefined || this.userData.isManager === false)" id="topdiv" class="modal-overlay" style="width: 100%; ">
        <div class="modal" style="outline:0.0em solid blue; display: table-cell; padding-top: 0vh; padding-bottom: 0vh; background-color:#EDF2F7; box-shadow: 0 0px 0px rgba(0, 0, 0, 0.0);" :style="{ 'height': 98 * this.vhMult + 'vh'}"> 
            <table cellspacing="0" cellpadding="0" width=100% border=0 style="margin: auto; padding-left: 0vh; padding-right: 0vh; ">
                <tr>
                    <td>
                        <table width="100%" border=0 style="height: 4.5vh">
                            <tr>
                                <td width="50%">
                                    <div class=divl><button class="text-only-button cancel" @click="this.goBack()" style="display: block;" :style="{ 'font-size': fontSizeNormalInPXToUse + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }"><span v-if="this.userData.isRecipient===false">Home</span><span v-else><img class="tulogo" valign=middle style="height: 1.8vh; padding-bottom: 0.3vh" alt="back" src="../assets/chevron.png"> Back</span></button></div>
                                </td>
                                <td width="50%">
                                    <div class=divr>
                                    
                                        <button @click="this.doLogout()" class="text-only-button cancel divr"  :style="{ 'font-size': fontSizeNormalInPXToUse + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }">Log out</button>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            
                <tr><td height=1vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr>

                <div class="userinfoframenowidth" style="height: 15vh; cursor: pointer;">
                    <table style="height:85%;" border=0 width=100%>
                        <thead>
                            <tr @click="this.doRecipientAccountEdit();" style="font-size: 0">
                                <td align=left width=25% style="height: 8vh; font-size: 0; text-align: center"><img :src="this.userImageDataURL" style="height: 12vh; border-radius:50%"></td>
                                <td >
                                    <!-- nested table -->
                                    <table width=100%>
                                    <tr>
                                        <td class="username"> {{ this.userData.displayname }}</td>
                                    </tr>
                                    <tr>
                                        <td class="businessname"><span v-if="this.user.emailDisplay">{{ this.user.emailDisplay }}</span></td> 
                                        
                                    </tr>
                                    <tr v-if="this.user.connectedTo!==undefined">
                                        <td class="lt-blue divl" :style="{ 'font-size': fontSizeNormalInPXToUse * 0.8 + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }">{{ this.user.connectedTo }}</td> 
                                        
                                    </tr>
                                    </table>
                                </td>
                                <td align=right width=10% >
                                    <img class="tulogo" style="height: 1.8vh;" alt="edit" src="../assets/chevronright.png">
                                </td>
                            </tr>
                        </thead>
                    </table>
                </div>
               
                <tr v-if="this.showRecipientAccountScreen === true"><td height=1.5vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr>           
                <tr v-if="this.showRecipientAccountScreen === true">
                    <td height=1.5vh >
                        <table width="100%" border=0 style="height: 1.5vh">
                            <tr>
                                <td width="100%">
                                    <div class="divl" style="color: #718096; font-weight: 600;" :style="{ 'font-size': fontSizeNormalInPXToUse * 0.7 + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }">PAYOUTS</div>
                                </td>
                            </tr>
                        </table>
                        
                    </td>
                </tr>
                <tr v-if="this.showRecipientAccountScreen === true && this.userData.receiveLast4!==undefined" @click="doShowPayouts();">
                    <td>
                        <table align=left style="height:6.5vh; background-color: white; border-radius: 10px; cursor: pointer" border=0 width=100% >
                            
                            <tr>

                                <td align=center width=15% class="lt-blue divc">
                                    <img style="height: 3vh; vertical-align:middle" alt="back" src="../assets/payoutsicon.png">
                                </td>
                                
                                <td align=left width=75% class="lt-blue divl" style="height: 1vh; letter-spacing: -0.41px; color:1A202C" :style="{ 'font-size': fontSizeRecordInPXToUse + 'px', 'line-height': fontSizeRecordInPXLineHeightToUse + 'px', }">
                                    Payouts
                                </td>
                                <td align=right width=10% >
                                    <img class="tulogo" style="height: 1.8vh;" alt="show payouts screen" src="../assets/chevronright.png">
                                </td>
                                
                            </tr>
                        </table>      
                    </td>
                </tr>
                <tr v-if="this.showRecipientAccountScreen === true"><td height=1.5vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr>   
                <tr v-if="this.showRecipientAccountScreen === true" @click="this.doConnectBankAccount();">
                    <td>
                        <table align=left style="height:6.5vh; background-color: white; border-radius: 10px; cursor: pointer" border=0 width=100% >
                            
                            <tr>

                                <td align=center width=15% class="lt-blue divc">
                                    <img style="height: 3vh; vertical-align:middle" alt="back" src="../assets/editicon.png">
                                </td>
                                
                                <td align=left width=75% class="lt-blue divl" style="height: 1vh; letter-spacing: -0.41px; color:1A202C" :style="{ 'font-size': fontSizeRecordInPXToUse + 'px', 'line-height': fontSizeRecordInPXLineHeightToUse + 'px', }">
                                    <span v-if="this.userData.receiveLast4===undefined">Connect bank account</span><span v-else>Paying to {{ this.userData.accountNameAbbr }}  {{ this.userData.receiveLast4 }}</span>
                                </td>
                                <td align=right width=10% >
                                    <img class="tulogo" style="height: 1.8vh;" alt="connect bank account" src="../assets/chevronright.png">
                                </td>
                                
                            </tr>
                        </table>      
                    </td>
                </tr>
                <tr v-if="this.showRecipientAccountScreen === true"><td height=1.5vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr> 

                <tr v-if="this.showRecipientAccountScreen === true">
                    <td height=1.5vh >
                        <table width="100%" border=0 style="height: 1.5vh">
                            <tr>
                                <td width="100%">
                                    <div class="divl" style="color: #718096; font-weight: 600;" :style="{ 'font-size': fontSizeNormalInPXToUse * 0.7 + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }">MANAGE</div>
                                </td>
                            </tr>
                        </table>
                        
                    </td>
                </tr>
                <tr v-if="this.showRecipientAccountScreen === true && this.isPoolMaster === true">
                    <td>
                        <table align=left style="height:6.5vh; background-color: white; border-radius: 10px; cursor: pointer" border=0 width=100% @click="doShowManageConnectedUsers();">
                            
                            <tr>

                                <td align=center width=15% class="lt-blue divc">
                                    <img style="height: 3vh; vertical-align:middle" alt="back" src="../assets/manageconnectedusersicon.png">
                                </td>
                                
                                <td align=left width=75% class="lt-blue divl" style="height: 1vh; letter-spacing: -0.41px; color:1A202C" :style="{ 'font-size': fontSizeRecordInPXToUse + 'px', 'line-height': fontSizeRecordInPXLineHeightToUse + 'px', }">
                                    Manage connected users
                                </td>
                                <td align=right width=10% >
                                    <img class="tulogo" style="height: 1.8vh;" alt="manage connected users" src="../assets/chevronright.png">
                                </td>
                                
                            </tr>
                        </table>      
                    </td>
                </tr>
                <tr v-if="this.showRecipientAccountScreen === true && this.isPoolMaster === true"><td height=1.5vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr> 
                <tr v-if="this.showRecipientAccountScreen === false">
                    <td height=1.5vh >
                        <table width="100%" border=0 style="height: 1.5vh">
                            <tr>
                                <td width="100%">
                                    <div class="divl" style="color: #718096; font-weight: 600;" :style="{ 'font-size': fontSizeNormalInPXToUse * 0.7 + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }">ACCOUNT</div>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                 <tr v-if="this.showRecipientAccountScreen === false" @click="this.doTipWithoutScanning()">
                    <td>
                        <table align=left style="height:6.5vh; background-color: white; border-radius: 10px; cursor: pointer" border=0 width=100% >
                            
                            <tr>

                                <td align=center width=15% class="lt-blue divc">
                                    <img style="height: 3vh; vertical-align:middle" alt="back" src="../assets/payoutsicongreen.png">
                                </td>
                                
                                <td align=left width=75% class="lt-blue divl" style="height: 1vh; letter-spacing: -0.41px; color:1A202C" :style="{ 'font-size': fontSizeRecordInPXToUse + 'px', 'line-height': fontSizeRecordInPXLineHeightToUse + 'px', }">
                                    Tip without scanning
                                </td>
                                <td align=right width=10% >
                                    <img class="tulogo" style="height: 1.8vh;" alt="order ThankU badges" src="../assets/chevronright.png">
                                </td>
                            </tr>
                            <tr v-if="this.user.mostRecentSalonVisited !== ''">
                                <td colspan=3 width="100%" style="color: #718096; font-size: 14px;" >
                                    at: {{this.user.mostRecentSalonVisited}} &nbsp;&nbsp;<button class="widebtn" style="width: 30%; font-size: 14px" @click="this.handleChangeButtonEvent($event)">Change</button>         
                                </td>
                            </tr>
                        </table>      
                    </td>
                </tr>
                <tr v-if="this.isPoolMaster === false"><td height=1.5vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr> 
                <tr v-if="this.isPoolMaster === false" @click="this.doShowTipHistory()">
                    <td>
                        <table align=left style="height:6.5vh; background-color: white; border-radius: 10px; cursor: pointer" border=0 width=100% >
                            
                            <tr>

                                <td align=center width=15% class="lt-blue divc">
                                    <img style="height: 3vh; vertical-align:middle" alt="back" src="../assets/orderfreeicon.png">
                                </td>
                                
                                <td align=left width=75% class="lt-blue divl" style="height: 1vh; letter-spacing: -0.41px; color:1A202C" :style="{ 'font-size': fontSizeRecordInPXToUse + 'px', 'line-height': fontSizeRecordInPXLineHeightToUse + 'px', }">
                                    Transaction history
                                </td>
                                <td align=right width=10% >
                                    <img class="tulogo" style="height: 1.8vh;" alt="order ThankU badges" src="../assets/chevronright.png">
                                </td>
                            </tr>
                        </table>      
                    </td>
                </tr>
                <tr v-if="this.isPoolMaster === false"><td height=1.5vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr> 

                <!-- <tr v-if="this.showRecipientAccountScreen === true && this.user.userId === '2fBkimFcIw'" >
                    <td>
                        <p></p>
                        <div><button class="widebtn" style="width: 70%; height: 5vh;" @click="this.doShowPersonalDetails();">Personal Details</button></div>
                    </td>
                </tr>
                <tr v-if="this.showRecipientAccountScreen === true && this.user.userId === '2fBkimFcIw'" >
                    <td>
                        <p></p>
                        <div><button class="widebtn" style="width: 70%; height: 5vh;" @click="this.doShowDocumentUpload();">Upload Documents</button></div>
                    </td>
                </tr> -->
                <tr v-if="this.showRecipientAccountScreen === true" @click="this.orderThankUBadges();">
                    <td>
                        <table align=left style="height:6.5vh; background-color: white; border-radius: 10px; cursor: pointer" border=0 width=100% >
                            
                            <tr>

                                <td align=center width=15% class="lt-blue divc">
                                    <img style="height: 3vh; vertical-align:middle" alt="back" src="../assets/orderfreeicon.png">
                                </td>
                                
                                <td align=left width=75% class="lt-blue divl" style="height: 1vh; letter-spacing: -0.41px; color:1A202C" :style="{ 'font-size': fontSizeRecordInPXToUse + 'px', 'line-height': fontSizeRecordInPXLineHeightToUse + 'px', }">
                                    Order free ThankU badges
                                </td>
                                <td align=right width=10% >
                                    <img class="tulogo" style="height: 1.8vh;" alt="order ThankU badges" src="../assets/chevronright.png">
                                </td>
                            </tr>
                        </table>      
                    </td>
                </tr>
                <tr v-if="this.showRecipientAccountScreen === true"><td height=1.5vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr> 
                <!-- we aren't using below any more because it is not possible to creat4e a payment method on Ryft except at the time of a payment -->
                <tr v-if="this.showRecipientAccountScreen === false && false" >
                    <!-- cant see a need for this until we get back into pools at which point we may do it differently anyway -->
                    <td>
                        <table align=left style="height:6.5vh; background-color: white; border-radius: 10px; cursor: pointer" border=0 width=100% @click="doShowPaymentMethods();">
                            
                            <tr>

                                <td align=center width=15% class="lt-blue divc">
                                    <img style="height: 3vh; vertical-align:middle" alt="back" src="../assets/managebadgesicon.png">
                                </td>
                                
                                <td align=left width=75% class="lt-blue divl" style="height: 1vh; letter-spacing: -0.41px; color:1A202C" :style="{ 'font-size': fontSizeRecordInPXToUse + 'px', 'line-height': fontSizeRecordInPXLineHeightToUse + 'px', }">
                                    Payment methods
                                </td>
                                <td align=right width=10% >
                                    <img class="tulogo" style="height: 1.8vh;" alt="manage ThankU badges" src="../assets/chevronright.png">
                                </td>
                                
                            </tr>
                        </table>      
                    </td>
                </tr>
                
                <tr v-if="this.showRecipientAccountScreen === false"><td height=1.5vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr> 
                <tr>
                    <td height=1.5vh >
                        <table width="100%" border=0 style="height: 1.5vh">
                            <tr>
                                <td width="100%">
                                    <div class="divl" style="color: #718096; font-weight: 600;" :style="{ 'font-size': fontSizeNormalInPXToUse * 0.7 + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }">THANKU</div>
                                </td>
                            </tr>
                        </table>
                        
                    </td>
                </tr>
                <tr v-if="this.showRecipientAccountScreen === true" >
                    <td>
                        <table align=left style="height:6.5vh; background-color: white; border-radius: 10px; cursor: pointer" border=0 width=100% @click="this.doShowTippingOptions()">
                            
                            <tr>

                                <td align=center width=15% class="lt-blue divc">
                                    <img style="height: 3vh; vertical-align:middle" alt="back" src="../assets/recipientgivetipicon.png">
                                </td>
                                
                                <td align=left width=75% class="lt-blue divl" style="height: 1vh; letter-spacing: -0.41px; color:1A202C" :style="{ 'font-size': fontSizeRecordInPXToUse + 'px', 'line-height': fontSizeRecordInPXLineHeightToUse + 'px', }"><span v-if="this.hasGivenTipsBefore===true">View your tip giving account</span><span v-else>Tip another user</span>
                                </td>
                                <td align=right width=10% >
                                    <img class="tulogo" style="height: 1.8vh;" alt="tip another user" src="../assets/chevronright.png">
                                </td>
                                
                            </tr>
                        </table>      
                    </td>
                </tr>
                <tr v-if="this.showRecipientAccountScreen === false" >
                    <td>
                        <table align=left style="height:6.5vh; background-color: white; border-radius: 10px; cursor: pointer" border=0 width=100% @click="this.doShowRecipientOptions()">
                            
                            <tr>

                                <td align=center width=15% class="lt-blue divc">
                                    <img style="height: 3vh; vertical-align:middle" alt="back" src="../assets/recipientgivetipicon.png">
                                </td>
                                
                                <td align=left width=75% class="lt-blue divl" style="height: 1vh; letter-spacing: -0.41px; color:1A202C" :style="{ 'font-size': fontSizeRecordInPXToUse + 'px', 'line-height': fontSizeRecordInPXLineHeightToUse + 'px', }"><span v-if="this.hasReceivedTipsBefore===true">View your tip receiving account</span><span v-else>How to receive tips</span>
                                </td>
                                <td align=right width=10% >
                                    <img class="tulogo" style="height: 1.8vh;" alt="tip another user" src="../assets/chevronright.png">
                                </td>
                                
                            </tr>
                        </table>      
                    </td>
                </tr>
                <tr><td height=1.5vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr> 
                <tr>
                    <td>
                        <table align=left style="height:6.5vh; background-color: white; border-radius: 10px; cursor: pointer" border=0 width=100% @click="getHelp()">
                            
                            <tr>

                                <td align=center width=15% class="lt-blue divc">
                                    <img style="height: 3vh; vertical-align:middle" alt="back" src="../assets/helpicon.png">
                                </td>
                                
                                <td align=left width=75% class="lt-blue divl" style="height: 1vh; letter-spacing: -0.41px; color:1A202C" :style="{ 'font-size': fontSizeRecordInPXToUse + 'px', 'line-height': fontSizeRecordInPXLineHeightToUse + 'px', }">
                                    Help
                                </td>
                                <td align=right width=10% >
                                    <img class="tulogo" style="height: 1.8vh;" alt="help" src="../assets/chevronright.png">
                                </td>
                                
                            </tr>
                        </table>      
                    </td>
                </tr>
                <tr><td height=1.5vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr> 
                <tr v-if="this.isSuperuser===true">
                    <td>
                        <table align=left style="height:6.5vh; background-color: white; border-radius: 10px; cursor: pointer" border=0 width=100% @click="doOperations()">
                            
                            <tr>

                                <td align=center width=15% class="lt-blue divc">
                                    <img style="height: 3vh; vertical-align:middle" alt="back" src="../assets/helpicon.png">
                                </td>
                                
                                <td align=left width=75% class="lt-blue divl" style="height: 1vh; letter-spacing: -0.41px; color:1A202C" :style="{ 'font-size': fontSizeRecordInPXToUse + 'px', 'line-height': fontSizeRecordInPXLineHeightToUse + 'px', }">
                                    Operations
                                </td>
                                <td align=right width=10% >
                                    <img class="tulogo" style="height: 1.8vh;" alt="help" src="../assets/chevronright.png">
                                </td>
                                
                            </tr>
                        </table>      
                    </td>
                </tr>
                <tr><td height=1.5vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr> 
                <tr v-if="this.isSuperuser===true">
                    <td>
                        <table align=left style="height:6.5vh; background-color: white; border-radius: 10px; cursor: pointer" border=0 width=100% @click="doManagementDashboard()">
                            
                            <tr>

                                <td align=center width=15% class="lt-blue divc">
                                    <img style="height: 3vh; vertical-align:middle" alt="back" src="../assets/helpicon.png">
                                </td>
                                
                                <td align=left width=75% class="lt-blue divl" style="height: 1vh; letter-spacing: -0.41px; color:1A202C" :style="{ 'font-size': fontSizeRecordInPXToUse + 'px', 'line-height': fontSizeRecordInPXLineHeightToUse + 'px', }">
                                    MI
                                </td>
                                <td align=right width=10% >
                                    <img class="tulogo" style="height: 1.8vh;" alt="help" src="../assets/chevronright.png">
                                </td>
                                
                            </tr>
                        </table>      
                    </td>
                </tr>

                <tr><td height=1.5vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr> 
            </table> 
        </div>
    </div>
    <div v-show="this.showAccountScreen===true && this.userData.isManager !== undefined && this.userData.isManager === true" id="topdiv" class="modal-overlay" style="width: 100%; ">
        <div class="modal" style="outline:0.0em solid blue; display: table-cell; padding-top: 0vh; padding-bottom: 0vh; background-color:#EDF2F7; box-shadow: 0 0px 0px rgba(0, 0, 0, 0.0);" :style="{ 'height': 98 * this.vhMult + 'vh'}"> 
            <table v-if="this.isLK===true" cellspacing="0" cellpadding="0" width=100% border=0 style="margin: auto; padding-left: 0vh; padding-right: 0vh; ">
                <!-- <tr>
                    <td>
                        <table width="100%" border=0 style="height: 4.5vh">
                            <tr>
                                <td width="50%">
                                    <div class=divl><button class="text-only-button cancel" @click="this.goBack()" style="display: block;" :style="{ 'font-size': fontSizeNormalInPXToUse + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }"><span v-if="this.userData.isRecipient===false">Home</span><span v-else><img class="tulogo" valign=middle style="height: 1.8vh; padding-bottom: 0.3vh" alt="back" src="../assets/chevron.png"> Back</span></button></div>
                                </td>
                                <td width="50%">
                                    <div class=divr>
                                    
                                        <button @click="this.doLogout()" class="text-only-button cancel divr"  :style="{ 'font-size': fontSizeNormalInPXToUse + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }">Log out</button>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr> -->
            
                <tr><td height=1vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr>

                <div class="userinfoframenowidth" style="height: 15vh; cursor: pointer;">
                    <table style="height:85%;" border=0 width=100%>
                        <thead>
                            <!-- <tr @click="this.doRecipientAccountEdit();" style="font-size: 0"> -->
                            <tr style="font-size: 0">
                                <td align=left width=25% style="height: 8vh; font-size: 0; text-align: center"><img :src="this.userImageDataURL" style="height: 12vh; border-radius:50%"></td>
                                <td >
                                    <!-- nested table -->
                                    <table width=100%>
                                    <tr>
                                        <td class="username"> {{ this.userData.displayname }}</td>
                                    </tr>
                                    <tr>
                                        <td class="businessname"><span v-if="this.user.emailDisplay">{{ this.user.emailDisplay }}</span></td> 
                                        
                                    </tr>
                                    <tr v-if="this.user.connectedTo!==undefined">
                                        <td class="lt-blue divl" :style="{ 'font-size': fontSizeNormalInPXToUse * 0.8 + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }">{{ this.user.connectedTo }}</td> 
                                        
                                    </tr>
                                    </table>
                                </td>
                                <td align=right width=10% >
                                    <!-- <img class="tulogo" style="height: 1.8vh;" alt="edit" src="../assets/chevronright.png"> -->
                                </td>
                            </tr>
                        </thead>
                    </table>
                </div>
                <tr><td height=1vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr>
                
                <tr v-if="this.showRecipientAccountScreen === false">
                    <td height=1.5vh >
                        <table width="100%" border=0 style="height: 1.5vh">
                            <tr>
                                <td width="100%">
                                    <div class="divc" style="color: #718096; font-weight: 600;" :style="{ 'font-size': fontSizeNormalInPXToUse * 0.9 + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }">REMOVE STAFF</div>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr><td height=1vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr>
                <tr><td height=1vh style="height:1vh; line-height:2vh; font-size: 14px;" >Tap the salon name to show the salon's staff list. <br /> <br />Then tap the name of a staff member to remove them from your list.<br /> <br />You will be asked to confirm before the removal finishes.<br /> <br /><br /> <br /></td></tr>
                 
                <tr v-if="this.showRecipientAccountScreen === false" @click="this.doTipWithoutScanningLKSK()">
                    <td>
                        <table align=left style="height:6.5vh; background-color: white; border-radius: 10px; cursor: pointer" border=0 width=100% >
                            <tr>
                                <td align=center width=15% class="lt-blue divc">
                                    <img style="height: 3vh; vertical-align:middle" alt="back" src="../assets/settingsmanager.png">
                                </td>
                                <td align=left width=75% class="lt-blue divl" style="height: 1vh; letter-spacing: -0.41px; color:1A202C" :style="{ 'font-size': fontSizeRecordInPXToUse + 'px', 'line-height': fontSizeRecordInPXLineHeightToUse + 'px', }">
                                    South Kensington
                                </td>
                                <td align=right width=10% >
                                    <img class="tulogo" style="height: 1.8vh;" alt="order ThankU badges" src="../assets/chevronright.png">
                                </td>
                            </tr>
                        </table>      
                    </td>
                </tr>

                <tr><td height=1vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr>

                <tr v-if="this.showRecipientAccountScreen === false" @click="this.doTipWithoutScanningLKWBG()">
                    <td>
                        <table align=left style="height:6.5vh; background-color: white; border-radius: 10px; cursor: pointer" border=0 width=100% >
                            <tr>
                                <td align=center width=15% class="lt-blue divc">
                                    <img style="height: 3vh; vertical-align:middle" alt="back" src="../assets/settingsmanager.png">
                                </td>
                                <td align=left width=75% class="lt-blue divl" style="height: 1vh; letter-spacing: -0.41px; color:1A202C" :style="{ 'font-size': fontSizeRecordInPXToUse + 'px', 'line-height': fontSizeRecordInPXLineHeightToUse + 'px', }">
                                    Westbourne Grove
                                </td>
                                <td align=right width=10% >
                                    <img class="tulogo" style="height: 1.8vh;" alt="order ThankU badges" src="../assets/chevronright.png">
                                </td>
                            </tr>
                        </table>      
                    </td>
                </tr>

                <tr><td height=1vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr>
                <tr v-if="this.showRecipientAccountScreen === false" @click="this.doTipWithoutScanningLKM()">
                    <td>
                        <table align=left style="height:6.5vh; background-color: white; border-radius: 10px; cursor: pointer" border=0 width=100% >
                            <tr>
                                <td align=center width=15% class="lt-blue divc">
                                    <img style="height: 3vh; vertical-align:middle" alt="back" src="../assets/settingsmanager.png">
                                </td>
                                <td align=left width=75% class="lt-blue divl" style="height: 1vh; letter-spacing: -0.41px; color:1A202C" :style="{ 'font-size': fontSizeRecordInPXToUse + 'px', 'line-height': fontSizeRecordInPXLineHeightToUse + 'px', }">
                                    Marylebone
                                </td>
                                <td align=right width=10% >
                                    <img class="tulogo" style="height: 1.8vh;" alt="order ThankU badges" src="../assets/chevronright.png">
                                </td>
                            </tr>
                        </table>      
                    </td>
                </tr>
    

                <tr><td height=1.5vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr> 
            </table> 
            <table v-if="this.isQuan===true" cellspacing="0" cellpadding="0" width=100% border=0 style="margin: auto; padding-left: 0vh; padding-right: 0vh; ">
            
                <tr><td height=1vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr>

                <div class="userinfoframenowidth" style="height: 15vh; cursor: pointer;">
                    <table style="height:85%;" border=0 width=100%>
                        <thead>
                            <!-- <tr @click="this.doRecipientAccountEdit();" style="font-size: 0"> -->
                            <tr style="font-size: 0">
                                <td align=left width=25% style="height: 8vh; font-size: 0; text-align: center"><img :src="this.userImageDataURL" style="height: 12vh; border-radius:50%"></td>
                                <td >
                                    <!-- nested table -->
                                    <table width=100%>
                                    <tr>
                                        <td class="username"> {{ this.userData.displayname }}</td>
                                    </tr>
                                    <tr>
                                        <td class="businessname"><span v-if="this.user.emailDisplay">{{ this.user.emailDisplay }}</span></td> 
                                        
                                    </tr>
                                    <tr v-if="this.user.connectedTo!==undefined">
                                        <td class="lt-blue divl" :style="{ 'font-size': fontSizeNormalInPXToUse * 0.8 + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }">{{ this.user.connectedTo }}</td> 
                                        
                                    </tr>
                                    </table>
                                </td>
                                <td align=right width=10% >
                                    <!-- <img class="tulogo" style="height: 1.8vh;" alt="edit" src="../assets/chevronright.png"> -->
                                </td>
                            </tr>
                        </thead>
                    </table>
                </div>
                <tr><td height=1vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr>
                
                <tr v-if="this.showRecipientAccountScreen === false">
                    <td height=1.5vh >
                        <table width="100%" border=0 style="height: 1.5vh">
                            <tr>
                                <td width="100%">
                                    <div class="divc" style="color: #718096; font-weight: 600;" :style="{ 'font-size': fontSizeNormalInPXToUse * 0.9 + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }">REMOVE STAFF</div>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr><td height=1vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr>
                <tr><td height=1vh style="height:1vh; line-height:2vh; font-size: 14px;" >Tap the salon name to show the salon's staff list. <br /> <br />Then tap the name of a staff member to remove them from your list.<br /> <br />You will be asked to confirm before the removal finishes.<br /> <br /><br /> <br /></td></tr>
                 
                <tr v-if="this.showRecipientAccountScreen === false" @click="this.doTipWithoutScanningQuanChelsea()">
                    <td>
                        <table align=left style="height:6.5vh; background-color: white; border-radius: 10px; cursor: pointer" border=0 width=100% >
                            <tr>
                                <td align=center width=15% class="lt-blue divc">
                                    <img style="height: 3vh; vertical-align:middle" alt="back" src="../assets/settingsmanager.png">
                                </td>
                                <td align=left width=75% class="lt-blue divl" style="height: 1vh; letter-spacing: -0.41px; color:1A202C" :style="{ 'font-size': fontSizeRecordInPXToUse + 'px', 'line-height': fontSizeRecordInPXLineHeightToUse + 'px', }">
                                    Chelsea
                                </td>
                                <td align=right width=10% >
                                    <img class="tulogo" style="height: 1.8vh;" alt="order ThankU badges" src="../assets/chevronright.png">
                                </td>
                            </tr>
                        </table>      
                    </td>
                </tr>

                <tr><td height=1vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr>

                <tr v-if="this.showRecipientAccountScreen === false" @click="this.doTipWithoutScanningQuanKensington()">
                    <td>
                        <table align=left style="height:6.5vh; background-color: white; border-radius: 10px; cursor: pointer" border=0 width=100% >
                            <tr>
                                <td align=center width=15% class="lt-blue divc">
                                    <img style="height: 3vh; vertical-align:middle" alt="back" src="../assets/settingsmanager.png">
                                </td>
                                <td align=left width=75% class="lt-blue divl" style="height: 1vh; letter-spacing: -0.41px; color:1A202C" :style="{ 'font-size': fontSizeRecordInPXToUse + 'px', 'line-height': fontSizeRecordInPXLineHeightToUse + 'px', }">
                                    Kensington
                                </td>
                                <td align=right width=10% >
                                    <img class="tulogo" style="height: 1.8vh;" alt="order ThankU badges" src="../assets/chevronright.png">
                                </td>
                            </tr>
                        </table>      
                    </td>
                </tr>

                <tr><td height=1.5vh style="height:1vh; line-height:2vh" >&nbsp;</td></tr> 
            </table> 
        </div>
    </div>
    <AccountEditScreen :key="componentKey" v-if="this.showAccountScreenEdit===true" :userData='this.userData' @next-action="doNext"/>
    <AccountPaymentMethodScreen :key="componentKey" v-if="this.showAccountPaymentMethodScreen===true" :userData='this.userData' @next-action="doNext"/>
    <VerificationRequiredScreen :key="componentKey" v-if="this.showVerificationRequired" :userData='this.userData' @next-action="doNext"/>
    
    
    
</template>

<script>

const Parse = require('parse/node');

import shared from '../shared.js';
import {loadStripe} from '@stripe/stripe-js/pure';

import AccountEditScreen from './AccountEdit.vue';
import AccountPaymentMethodScreen from './AccountPaymentMethod.vue';
import VerificationRequiredScreen from './VerificationRequiredScreen.vue';

export default {
    name: 'RecipientDashboardScreen',
    inject: ['globalPushForwardInterval', 'devEnv', 'appId', 'appJSKey'] ,
    props:  {
        userData: shared.userDataStruct(),
    },
    components: {
        AccountEditScreen,
        AccountPaymentMethodScreen,
        VerificationRequiredScreen,
    },
    data () {
        return {
            fontSizeNormal: 3.0, // vh
            fontSizeNormalInPXToUse: "",
            fontSizeNormalLineHeight: 3.6,// vh
            fontSizeNormalInPXLineHeightToUse: "",
            fontSizeRecord: 3.0, // vh
            fontSizeRecordInPXToUse: "",
            fontSizeRecordLineHeight: 3.0,// vh
            fontSizeRecordInPXLineHeightToUse: "",
            user: {
                userId : ""
                },
            userImageDataURL: "",
            showPopUpTwoOptions: false,
            PopUpTwoOptionsTitle: "",
            PopUpTwoOptionsMessage: "",  
            PopUpTwoOptionsMessage2: "",
            PopUpTwoOptionsMessage3: "",
            option1ButtonText: "",
            option2ButtonText: "",
            showAccountScreenEdit: false,
            showAccountPaymentMethodScreen: false,
            showAccountScreen: true,
            showButton1: true,
            componentKey: 0, // this is to be able to rerender the component so that the Account Photo Edit reloads
            vhMult: 0,
            showRecipientAccountScreen: false,
            hasGivenTipsBefore: false,
            hasReceivedTipsBefore: false,
            isPoolMaster: false,
            isSuperuser: false,
            stripePublishableKey: process.env.VUE_APP_STRIPE_ENV === "dev" ? process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY_TEST : process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY_LIVE,
            paymentSecret: "toops",
            showVerificationRequired: false,
            isLK: false,
            isQuan: false,
        }
    },
    methods: {
        doShowPersonalDetails() {
            console.log("about to show personal details");
            this.userData.nextScreen = 'showPersonalDetails';
            this.$emit('next-action', this.userData);
        },
        
        doShowDocumentUpload() {
            console.log("about to show document upload");
            this.userData.nextScreen = 'showDocumentUpload';
            this.$emit('next-action', this.userData);
        },
        handleChangeButtonEvent(event){
            event.stopPropagation();
            // console.log("do handleChangeButtonEvent");
            this.userData.nextScreen = "tipwithoutscanning";
            this.$emit("next-action", this.userData);
        },
        doTipWithoutScanningLKSK(){
            this.user.mostRecentSalonVisitedTUID = "00000001287";
            this.doTipWithoutScanning();
        },
        doTipWithoutScanningLKWBG(){
            this.user.mostRecentSalonVisitedTUID = "00000001341";
            this.doTipWithoutScanning();
        },
        doTipWithoutScanningLKM(){
            this.user.mostRecentSalonVisitedTUID = "00000002644";
            this.doTipWithoutScanning();
        },
        doTipWithoutScanningQuanChelsea(){
            this.user.mostRecentSalonVisitedTUID = "00000002392";
            this.doTipWithoutScanning();
        },
        doTipWithoutScanningQuanKensington(){
            this.user.mostRecentSalonVisitedTUID = "00000002470";
            this.doTipWithoutScanning();
        },
        doTipWithoutScanning(TUIDofVenueWherePoolMaster = null){

            if (TUIDofVenueWherePoolMaster !== null){
                this.user.mostRecentSalonVisitedTUID = TUIDofVenueWherePoolMaster;
            }

            if (this.user.mostRecentSalonVisitedTUID === ""){
                // console.log("do Tip without scanning");
                this.userData.nextScreen = "tipwithoutscanning";
                this.$emit("next-action", this.userData);
            } else {
                
                this.userData.mostRecentSalonVisitedTUID = this.user.mostRecentSalonVisitedTUID;
                
                window.localStorage.setItem("tutws", true);
                this.userData.nextScreen = "processTUID";
                // console.log("this.user.mostRecentSalonVisitedTUID: " + this.user.mostRecentSalonVisitedTUID);
                
                this.$emit("next-action", this.userData);
            }
        },
        forceRerender() {
            this.componentKey += 1;
        },
        doFontSizeComputed () {
        
            this.fontSizeNormalInPXToUse = shared.convertVHSizeToMaxPixelsSize(this.fontSizeNormal, 16);
            this.fontSizeNormalInPXLineHeightToUse = shared.convertVHSizeToMaxPixelsSize(this.fontSizeNormalLineHeight, 20);
            this.fontSizeRecordInPXToUse = shared.convertVHSizeToMaxPixelsSize(this.fontSizeRecord, 16);
            this.fontSizeRecordInPXLineHeightToUse = shared.convertVHSizeToMaxPixelsSize(this.fontSizeRecordLineHeight, 17);
        
        },
        async doNext(userData) {

            let nextAction = userData.nextScreen;

            console.log("nextAction USERDATA ON ACCOUNT SCREEN::: " + nextAction + "   user: " + JSON.stringify(userData, null, 2));
            console.log("nextAction ON ACCOUNT SCREEN::: " + nextAction );

            if (nextAction === "logOut") {
                await this.doLogout();
                nextAction = "showLoggedOut"; // just let it flow through to home page
            }

            
            if (nextAction === "showPersonalDetails") {
                this.showVerificationRequired = false;
                this.$emit('next-action', userData);
            } else if (nextAction === "ReloadAccountPhotoScreen") {
                // console.log("do ReloadAccountPhotoScreen screen");
                this.user.email = userData.email;

                this.user.emailDisplay = this.user.email;

                if (this.user.emailDisplay.length > 25) {
                    this.user.emailDisplay = this.user.emailDisplay.substring(0, 22) + "...";
                }

                this.user.userId = userData.userObjectId;

                if (userData.userThumbnail) {
                    this.userImageDataURL = userData.userThumbnail; // for display in this component
                    this.userData.userThumbnail = userData.userThumbnail; // for passing to next component
                    this.userData.goStraightToPhotoEdit = true;
                    // console.log("NEW USERDATA: " + JSON.stringify(this.userData));
                } else {
                    this.userImageDataURL = shared.getAccountPersonDataURL();
                    // console.log("using accountperson");
                }

                this.forceRerender();

            } else if (nextAction === "showAccountScreen") {
                // console.log("do account screen");

                this.showVerificationRequired = false;
                this.user.email = userData.email;

                this.user.emailDisplay = this.user.email;

                if (this.user.emailDisplay.length > 25) {
                    this.user.emailDisplay = this.user.emailDisplay.substring(0, 22) + "...";
                }
        
                this.user.userId = userData.userObjectId;

                if (userData.userThumbnail) {
                    this.userImageDataURL = userData.userThumbnail;
                    this.userData.userThumbnail = userData.userThumbnail; // for passing to next component
                }

                this.showAccountScreenEdit = false;
                this.showAccountPaymentMethodScreen = false;
                this.showAccountScreen = true;


                
            } else if (nextAction === "showAccountScreenFromPaymentMethodScreen") {
                // console.log("do account screen from payment method screen");
                this.userData.paymentMethod = userData.paymentMethod;

                this.showAccountScreenEdit = false;
                this.showAccountPaymentMethodScreen = false;
                this.showAccountScreen = true;
                
            } else {
                // console.log("doing next:: " + nextAction);
                let returnParentJSON = {
                    showHomeScreen: true,
                    redirect: nextAction
                };
                this.$emit('return-parent-json', returnParentJSON);
            }
        },
        async getUserThumbnail(userObjectId) {

            // console.log("objectID::: " + userObjectId);
    
            var params =  {};
            params["userObjectsArray"] = [{objectId: userObjectId}];
            params["mainOrThumb"] = "userPhoto";

            await Parse.Cloud.run("getUserPhotoThumbs", params).then( TUImageData => {
                if (TUImageData === undefined) {
                    
                    // do nothing, there's a problem getting the image, probably because it's saved in a replica DB
                } else {
                    // console.log("TUImageData::" + TUImageData + "::");
                    var hasFoundImage = false;
                    var i;
                    for (i = 0; i < TUImageData.length; i++) {
                        if (TUImageData[i][0] === userObjectId){
                            // console.log("doing 1");
                            this.userImageDataURL = 'data:image/' + TUImageData[i][2] + ';base64,' + TUImageData[i][1];
                            this.userData.userThumbnail = this.userImageDataURL;
                            // console.log("image2: " + this.userImageDataURL);
                            hasFoundImage = true;
                        } 
                    }
                    if (hasFoundImage === false) {
                        this.userImageDataURL = require('@/assets/accountperson.png');
                        this.userData.userThumbnail = this.userImageDataURL;
                    }
                }
            }).catch(function(error){
                // /console.log("BROWSER getUserPhotoThumbs FAILED");
                console.error(error);
                throw error;
            });
        },
        doShowTipHistory(){
            this.userData.fromScreen = "recipientAccountScreen";
            this.userData.nextScreen = "showTipHistory";
            if(this.showRecipientAccountScreen === true) {
                this.userData.tipHistoryMode = "recipient";
            } else {
                this.userData.tipHistoryMode = "tipper";
            }
            this.$emit("next-action", this.userData);
        },
        doRecipientAccountEdit(){
            this.showAccountScreenEdit = true;
            this.showAccountPaymentMethodScreen = false;
            this.showAccountScreen = false;
        },
        goBack(){
            if (this.showRecipientAccountScreen === true) {
                this.userData.nextScreen = "showRecipientDashboardScreen";
            } else {
                this.userData.nextScreen = "";
            }
            this.$emit("next-action", this.userData); 
        },
        doConnectBankAccount(){
            // console.log("doing connect bank account");
            this.showAccountScreen = false;
            this.userData.nextScreen = "connectBankAccount";
            this.$emit("next-action", this.userData);

        },
        doShowConnectBankAccountOptions(){
            this.PopUpTwoOptionsTitle = "Connect bank account";
            
            this.PopUpTwoOptionsMessage = "To receive tips with ThankU, you now need to connect your ThankU account to your bank account";
            this.PopUpTwoOptionsMessage2 = "";
            this.PopUpTwoOptionsMessage3 = "";
            this.option1ButtonText = "Connect";
            this.option2ButtonText = "Later";
            this.showHomeScreen = false;
            this.showPopUpTwoOptions = true;
        },
        doShowREConnectBankAccountOptions(){
            this.PopUpTwoOptionsTitle = "Reconnect bank account";
            
            this.PopUpTwoOptionsMessage = "Reconnect your ThankU account to your bank account to receive your tips next day";
            this.PopUpTwoOptionsMessage2 = "";
            this.PopUpTwoOptionsMessage3 = "";
            this.option1ButtonText = "Reconnect";
            this.option2ButtonText = "Later";
            this.showHomeScreen = false;
            this.showPopUpTwoOptions = true;
        },
        doShowPayouts(){
            // console.log("now I am on RecipientAccount and I should be: " + this.user.userId);
            this.userData.fromScreen = "showAccountScreen";
            this.userData.nextScreen = "showPayouts";
            // console.log("this.userData::: " + JSON.stringify(this.userData, null, 2));
            // Parse.Cloud.run("sendEmail", {
            //     toEmail: "appnotif@thanku.app", 
            //     subject: "ALERT! " + this.user.displayname + " viewed Payouts",
            //     body: "",
            // });
            this.$emit("next-action", this.userData);
        },
        doLogout(){
            this.userData.nextScreen = "logOut";
            this.$emit("next-action", this.userData);
        },
        orderThankUBadges(){
            window.localStorage.setItem("nextScreen", "showAccountScreen");
            this.userData.fromScreen = "showAccountScreen";
            // this.userData.nextScreen = "gettipsstart";
            this.userData.nextScreen = "gettipsstartnew";
            this.$emit("next-action", this.userData);

        },

        doShowManageThankUBadges(){
            this.PopUpTwoOptionsTitle = "Manage ThankU badges";
            
            this.PopUpTwoOptionsMessage = "I can't think of why anyone would need this in a salon context so leaving it for now";
            this.PopUpTwoOptionsMessage2 = "";
            this.PopUpTwoOptionsMessage3 = "";
            this.option1ButtonText = "Update your ThankU badges";
            this.option2ButtonText = "Ok";
            this.showHomeScreen = false;
            this.showPopUpTwoOptions = true;
        },

        doShowPaymentMethods(){
            
            this.showHomeScreen = false;
            this.showAccountScreenEdit = false;
            this.showAccountPaymentMethodScreen = true;
        },

        doShowManageConnectedUsers(){
            this.PopUpTwoOptionsTitle = "Manage connected users";
            
            this.PopUpTwoOptionsMessage = "Your staff set themselves up to receive tips with ThankU by scanning your business's ThankU QR badge and tapping 'get tips here...'. It typically takes them 1 minute if they have their bank details to hand. When staff leave, just email us - you can use the 'Update your ThankU list' button below, and we will remove them for you. We used to have an 'in app' way of doing this, but no one used it and everyone preferred to just email us!";
            this.PopUpTwoOptionsMessage2 = "";
            this.PopUpTwoOptionsMessage3 = "";
            this.option1ButtonText = "Update your ThankU list";
            this.option2ButtonText = "Ok";
            this.showHomeScreen = false;
            this.showPopUpTwoOptions = true;
        },
        doShowTippingOptions(){

            if (this.hasGivenTipsBefore === true){
                this.showRecipientAccountScreen = false;
            } else {
                this.PopUpTwoOptionsTitle = "Tip another user";
                
                this.PopUpTwoOptionsMessage = "To tip with ThankU, if you are at the location where the person you want to tip is, simply scan the ThankU QR badge just the same as any other ThankU user, and if you aren't, you can use the Tip Without Scanning button below - choose the business where they work from the list, and then tip as normal.";
                this.PopUpTwoOptionsMessage2 = "";
                this.PopUpTwoOptionsMessage3 = "";
                this.option1ButtonText = "Tip without scanning";
                this.option2ButtonText = "Ok";
                this.showHomeScreen = false;
                this.showPopUpTwoOptions = true;

            }
            
        },
        doShowRecipientOptions(){

            if (this.hasReceivedTipsBefore === true){
                this.showRecipientAccountScreen = true;
            } else {
                this.PopUpTwoOptionsTitle = "How to receive tips";
                
                this.PopUpTwoOptionsMessage = "To get tips with ThankU, you need to request free ThankU QR badge media from us and/or we can set you up with your own ThankU link you can give your clients which will take them straight to your ThankU tipping page. To request either or both, just tap the 'Order free ThankU badges' button below";
                this.PopUpTwoOptionsMessage2 = "NOTE: ";
                this.PopUpTwoOptionsMessage3 = "If there is already ThankU QR media where you work and you want to receive tips there, simply scan the QR media just like a client, tap the 'get tips here' button and follow instructions";
                this.option1ButtonText = "Order free ThankU badges";
                this.option2ButtonText = "Ok";
                this.showHomeScreen = false;
                this.showPopUpTwoOptions = true;

            }
            
        },
        doOption1(){
            this.showPopUpTwoOptions = false;
            
            if (this.option1ButtonText === "Tip without scanning"){
                // console.log("do Tip without scanning");
                this.userData.nextScreen = "tipwithoutscanning";
                
                this.$emit("next-action", this.userData);
            } else if (this.option1ButtonText === "Order free ThankU badges"){
                this.orderThankUBadges();

            } else if (this.option1ButtonText === "Update your ThankU list"){
                const url = "mailto:updatethankulist@thanku.app?subject=request to update ThankU list&body=Just let us know which staff member or members you would like us to remove (or change) and we will get it done without delay... Just advise us their name as it appears in your list, or their email address..."

                window.open(url);
            } else if (this.PopUpTwoOptionsTitle === "Connect bank account"){
                
                window.localStorage.setItem("tuconnecttovenue", "bankAccountOnly");
                // console.log("DID SET tuconnecttovenue");
                this.doConnectBankAccount();
            } else if (this.PopUpTwoOptionsTitle === "Reconnect bank account"){
                
                window.localStorage.setItem("tuconnecttovenue", "bankAccountOnly");
                this.userData.connectToRyftOnly = true;
                this.doConnectBankAccount();
            }
            this.resetPopUpTwoOptions();
        },
        doOption2(){
            this.showPopUpTwoOptions = false;
            this.resetPopUpTwoOptions();
            
        },
        resetPopUpTwoOptions(){

            this.PopUpTwoOptionsTitle = "";
            this.PopUpTwoOptionsMessage = "";
            this.PopUpTwoOptionsMessage2 = "";
            this.PopUpTwoOptionsMessage3 = "";
            this.option1ButtonText = "";
            this.option2ButtonText = "";
            
        },
        getHelp(){
            window.localStorage.setItem("nextScreen", "showAccountScreen");
            
            if (this.showRecipientAccountScreen === true){
                window.localStorage.setItem("accountScreenStatus", "recipient");
                this.doShowGetTipsMoreInfo();
            } else {
                window.localStorage.setItem("accountScreenStatus", "tipper");
                this.doShowGiveTipsMoreInfo();
            }
        },
        doShowGetTipsMoreInfo(){
            // console.log("Yup");
            this.userData.nextScreen = "gettipsmoreinfo";
            this.$emit("next-action", this.userData);
            // this.$router.push('gettipsmoreinfo'); 
        },
        doShowGiveTipsMoreInfo(){
            // console.log("Yup");
            this.userData.nextScreen = "givetipsmoreinfo";
            this.$emit("next-action", this.userData);
            // this.$router.push('gettipsmoreinfo'); 
        },
        setUserTippingStatusVars(){


            if (this.userData.isRecipient === true){
                if (window.localStorage.getItem("accountScreenStatus") !== null && window.localStorage.getItem("accountScreenStatus") === "tipper") {
                    // console.log("IIISSSSSSSSSSSS recipient");
                    window.localStorage.removeItem("accountScreenStatus");
                    this.showRecipientAccountScreen = false;
                } else {
                    // console.log("IIISSSSSSSSSSSS tipper");
                    window.localStorage.removeItem("accountScreenStatus");
                    this.showRecipientAccountScreen = true;
                }
            } 
            if (this.userData.hasGivenTipsBefore === true){
                this.hasGivenTipsBefore = true;
            } 
            if (this.userData.hasReceivedTipsBefore === true){
                this.hasReceivedTipsBefore = true;
            }
            if (this.userData.isPoolMaster === true){
                this.isPoolMaster = true;
            }
        },
        doOperations(){
            this.userData.fromScreen = "showAccountScreen";
            this.userData.nextScreen = "showOperations";
            // console.log("this.userData::: " + JSON.stringify(this.userData, null, 2));
            this.$emit("next-action", this.userData);
        },
        doManagementDashboard(){
            this.userData.fromScreen = "showAccountScreen";
            this.userData.nextScreen = "showManagementDashboard";
            // console.log("this.userData::: " + JSON.stringify(this.userData, null, 2));
            this.$emit("next-action", this.userData);
        },
        setDelayedTitle(){
            document.title = "thankU"; // this is so if you save it to your home screen the proposed title is just 'ThankU'
        },
        async doStripeResilienceTest(){

            let errorType = "";
            let repeatInterval = 3000;

            try {

                let preTimeInMillis;
                let postTimeInMillis;

                preTimeInMillis = new Date().getTime();

                console.log("about to load Stripe in stripeResilienceTesting");  
                errorType = "loadStripe";
                let stripe = await loadStripe(this.stripePublishableKey); 

                
                postTimeInMillis = new Date().getTime();
                let secondsTaken = (postTimeInMillis - preTimeInMillis)/1000;
                console.log("JUST completed await load Stripe in stripeResilienceTesting");
                if (secondsTaken > 0.6) {
                    Parse.Cloud.run("sendEmail", { toEmail: "appalert@thanku.app", subject: "SLOW stripeResilienceTesting took " + secondsTaken.toFixed(1) + " seconds", body: ""}); 
                } else {
                    // Parse.Cloud.run("sendEmail", { toEmail: "appnotif@thanku.app", subject: "Normal stripeResilienceTesting took " + secondsTaken.toFixed(1) + " seconds", body: ""}); 
                }
                errorType = "canMakePayment";
                preTimeInMillis = new Date().getTime();
                let paymentRequestJSON = this.makePaymentRequestJSON("1", "TEST");
                // console.log("paymentRequestJSON: " + JSON.stringify(paymentRequestJSON, null, 2));
                let paymentRequest = stripe.paymentRequest(paymentRequestJSON);
                // console.log("paymentRequest: " + JSON.stringify(paymentRequest, null, 2));
                let result = await paymentRequest.canMakePayment();
                postTimeInMillis = new Date().getTime();
                secondsTaken = (postTimeInMillis - preTimeInMillis)/1000;
                console.log("JUST completed await canMakePayment in stripeResilienceTesting");
                if (secondsTaken > 0.6) {
                    Parse.Cloud.run("sendEmail", { toEmail: "appalert@thanku.app", subject: "SLOW CANMAKEPAYMENT in stripeResilienceTesting took " + secondsTaken.toFixed(1) + " seconds", body: ""}); 
                } else {
                    // Parse.Cloud.run("sendEmail", { toEmail: "appnotif@thanku.app", subject: "Normal stripeResilienceTesting took " + secondsTaken.toFixed(1) + " seconds", body: ""}); 
                }
                window.setTimeout(this.doStripeResilienceTest, repeatInterval); 
                
                
            } catch (e) {
                console.log("ERROR in stripeResilienceTesting: " + e.message);
                if (errorType === "loadStripe"){
                    Parse.Cloud.run("sendEmail", { toEmail: "appalert@thanku.app", subject: "ERROR LOADSTRIPE in stripeResilienceTesting ", body: "Error is: " + e.message}); 
                    window.setTimeout(this.doStripeResilienceTest, repeatInterval); 
                } else if (errorType === "canMakePayment"){
                    Parse.Cloud.run("sendEmail", { toEmail: "appalert@thanku.app", subject: "ERROR CANMAKEPAYMENT in stripeResilienceTesting ", body: "Error is: " + e.message}); 
                    window.setTimeout(this.doStripeResilienceTest, repeatInterval); 
                } else {
                    Parse.Cloud.run("sendEmail", { toEmail: "appalert@thanku.app", subject: "ERROR OTHER in stripeResilienceTesting ", body: "Error is: " + e.message}); 
                }

            }


        },
    },

    async created(){
        console.log("GET ME aCCOUNT SCREEN created");
        Parse.serverURL = 'https://parseapi.back4app.com/'; Parse.initialize(this.appId, this.appJSKey); (this.appId, this.appJSKey);
        
        clearTimeout(window.localStorage.getItem("networkMsgBoxTimeoutId"));
        document.getElementById('networkMsgBox').style.display = 'none';
        // console.log("userData on CREATING Account.vue: " + JSON.stringify(this.userData, null, 2));

        // console.log("this.userData: " + JSON.stringify(this.userData, null, 4));

        if (this.userData.userObjectId === "C6oBrZsC5a") {
            this.isLK = true;
        } 
        if (this.userData.userObjectId === "860BndvD89") {
            console.log("We ARE QUAN!");
            this.isQuan = true;
        } 
        this.user.displayname = this.userData.displayname; //window.localStorage.getItem("tudis");
        this.user.email = this.userData.email;

        if (this.userData.mostRecentSalonVisited !== undefined){
            this.user.mostRecentSalonVisited = this.userData.mostRecentSalonVisited;
            this.user.mostRecentSalonVisitedTUID = this.userData.mostRecentSalonVisitedTUID; // so if we did a LIVE DB reconcile rebuild then this might be undefined but the above mostRecentSalonVisited defined. Not the end of the world, they will simply get taken to the salons list rather than straight to the salon; no-one uses it anyway
        } else {
            this.user.mostRecentSalonVisited = "";
            this.user.mostRecentSalonVisitedTUID = "";
        }

        this.user.emailDisplay = this.user.email;

        if (this.user.emailDisplay.length > 25) {
            this.user.emailDisplay = this.user.emailDisplay.substring(0, 22) + "...";
        }

        this.user.userId = this.userData.userObjectId;
        if (this.userData.isSuperuser !== undefined){
            this.isSuperuser = this.userData.isSuperuser;
        }

        this.setUserTippingStatusVars();
    
        if (this.userData.venuesConnectedAtArray.length > 0){
            this.user.connectedTo = "getting tips at ";
            var connectorStr = "";
            for (const venue of this.userData.venuesConnectedAtArray) {
                this.user.connectedTo += connectorStr + venue.venueLocationShort ;
                connectorStr = ", ";
            }
        }

        // console.log("Account Screen USER: " + JSON.stringify(this.userData));
        
        if (this.userData.userPhotoFilename !== undefined) {
            window.localStorage.setItem("userPhotoFilename", this.userData.userPhotoFilename);
            // /alert("SET localstorage userPhotoFilename to: " + window.localStorage.getItem("userPhotoFilename"));
        }

        if (window.localStorage.getItem("userPhotoFileData") !== null) {

            const userPhotoFileType = window.localStorage.getItem("userPhotoFileType") !== null ? window.localStorage.getItem("userPhotoFileType") : 'jpeg';

            this.userImageDataURL = window.localStorage.getItem("userPhotoFileData");
            // console.log("doing 2");
            // this.userImageDataURL = 'data:image/' + userPhotoFileType + ';base64,' + window.localStorage.getItem("userPhotoFileData");

            // console.log("this.userImageDataURL: " + this.userImageDataURL);
            this.userData.userThumbnail = this.userImageDataURL;

            // /// / /alert("ALREADY HAD localStorage userPhotoFiledata: " + this.userImageDataURL);
          
        } else {
            // console.log("ok let's get the thumbnail!");
            await this.getUserThumbnail(window.localStorage.getItem("tuob"));
            
            // /// / /alert("had to getUserThumbnail: " + this.userData.userThumbnail);
        }

        if (this.userData.receiveLast4 === undefined && this.userData.isRecipient === true && window.localStorage.getItem("tuhassetupbank") === null){
            if (window.localStorage.getItem("dontDoShowConnectBankAccountOptions") === null){
                console.log("We can show doShowConnectBankAccountOptions");
                // window.localStorage.removeItem("suppressOneBankNag");
                this.doShowConnectBankAccountOptions();
                return;
            } else {
                // window.localStorage.setItem("suppressOneBankNag", "yes");
                // window.localStorage.removeItem("dontDoShowConnectBankAccountOptions");
                console.log("here we are");
            }
        }

        if (this.userData.isRecipient === true && this.userData.ryftConnAccId === undefined && this.userData.strConnAccId !== undefined && window.localStorage.getItem("tuhassetupbank") === null){
            if (window.localStorage.getItem("dontDoShowConnectBankAccountOptions") === null){
                console.log("We can show doShowConnectBankAccountOptions");
            
                this.doShowREConnectBankAccountOptions();
                return;
            } else {
                // window.localStorage.setItem("suppressOneBankNag", "yes");
                // window.localStorage.removeItem("dontDoShowConnectBankAccountOptions");
                console.log("here we are");
            }
        }

        // skip verification prompt if user already uploaded documents this session (flag set by DocumentUploadScreen on successful submit; resets on page reload)
        if (!this.userData.documentsUploaded && this.userData !== undefined && this.userData.ryftVerificationStatus !== undefined && (this.userData.ryftVerificationStatus !== "Verified" && this.userData.ryftVerificationStatus !== "ok")){
            this.showVerificationRequired = true;
            return; // Stop further processing until verification is addressed
        }




    },
    mounted(){

        this.doFontSizeComputed();
        this.vhMult = shared.setScreenHeightMultiplier();
        shared.saveToUserPath(this.devEnv, "Viewed account screen " + new Date().toISOString(), this.globalPushForwardInterval);   

        window.setTimeout(this.setDelayedTitle, 1500); 

    
        if (window.localStorage.getItem("willConnectRealUserDetails") !== null){
        
        //   alert("ON ACCOUNT willConnectRealUserDetails is still here");

        } else {
        //   alert("ON  ACCOUNT willConnectRealUserDetails WAS NOT THERE!!!!!");
        }

        console.log("this.userData: " + JSON.stringify(this.userData, null, 4));

        if (this.userData.isManager !== undefined){
            console.log("this.userData.isManager: " + this.userData.isManager);
        }
        
        if (this.isLK === false && this.isQuan === false && this.userData.isManager !== undefined && this.userData.isManager === true){
            if (this.userData.TUIDofVenueWherePoolMaster !== undefined) {
                this.doTipWithoutScanning(this.userData.TUIDofVenueWherePoolMaster);
                return;
            }
        }

    },
}
</script>

<style scoped>

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 8vh;
  height: 4vh;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 3vh;
  width: 3vh;
  left: 4px;
  bottom: 0.5vh;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #68D391;
}

input:focus + .slider {
  box-shadow: 0 0 1px #68D391;
}

input:checked + .slider:before {
  -webkit-transform: translateX(3.8vh);
  -ms-transform: translateX(3.8vh);
  transform: translateX(3.8vh);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

</style>